
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15.833a.834.834 0 110-1.667.834.834 0 010 1.667zm1.32-5.298a.837.837 0 00-.487.758v.374a.833.833 0 11-1.666 0v-.374a2.51 2.51 0 011.454-2.272c.849-.391 1.462-1.429 1.462-1.938A2.086 2.086 0 0012 7c-1.15 0-2.083.935-2.083 2.083a.833.833 0 11-1.667 0A3.755 3.755 0 0112 5.333a3.755 3.755 0 013.75 3.75c0 1.126-.977 2.781-2.43 3.452z","fill":"#282E3E"}})])
          )
        }
      }
    